import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Tag, Button, Drawer, Table, message, Tabs } from 'antd';
import PujaSpinner from '../../components/PujaSpinner';
import { buyerService } from '../../services/api';

const MisAnimales = () => {
  const [loading, setLoading] = useState(true);
  const [animales, setAnimales] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [movimientosData, setMovimientosData] = useState(null);
  const [loadingMov, setLoadingMov] = useState(false);

  useEffect(() => {
    fetchAnimales();
  }, []);

  const fetchAnimales = async () => {
    setLoading(true);
    try {
      const res = await buyerService.getMisAnimales();
      setAnimales(res.data || []);
    } catch (err) {
      message.error(err.response?.data?.error || 'Error al cargar animales');
    } finally {
      setLoading(false);
    }
  };

  const verMovimientos = async (idAnimal) => {
    setDrawerOpen(true);
    setMovimientosData(null);
    setLoadingMov(true);
    try {
      const res = await buyerService.getMovimientosAnimal(idAnimal);
      setMovimientosData(res.data);
    } catch (err) {
      message.error(err.response?.data?.error || 'Error al cargar movimientos');
      setDrawerOpen(false);
    } finally {
      setLoadingMov(false);
    }
  };

  const colsHembra = [
    { title: 'Fecha', dataIndex: 'fecha_aspiracion', key: 'fecha_aspiracion' },
    { title: 'Proveedor', dataIndex: 'proveedor', key: 'proveedor' },
    { title: 'Total embriones', dataIndex: 'total_embriones', key: 'total_embriones' },
  ];

  const colsMacho = [
    { title: 'Fecha', dataIndex: 'fecha_movimiento', key: 'fecha_movimiento' },
    { title: 'Proveedor', dataIndex: 'proveedor', key: 'proveedor' },
    { title: 'Total dosis', dataIndex: 'total_dosis', key: 'total_dosis' },
  ];

  if (loading) {
    return <PujaSpinner />;
  }

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>Mis Animales en Sociedad</h2>

      {animales.length === 0 ? (
        <Card>
          <p>No tenés animales en sociedad registrados.</p>
        </Card>
      ) : (
        <Row gutter={[16, 16]}>
          {animales.map((v) => {
            const animal = v.animal || {};
            return (
              <Col xs={24} sm={12} lg={8} key={v.id_venta}>
                <Card
                  title={animal.nom_animal || `Animal #${v.id_animal}`}
                  extra={
                    <Button size="small" onClick={() => verMovimientos(v.id_animal)}>
                      Ver movimientos
                    </Button>
                  }
                >
                  <p><strong>RP:</strong> {animal.rp_animal || '—'}</p>
                  <p><strong>% Participación:</strong> {v.porcentaje_venta}%</p>
                  <p><strong>Importe:</strong> {v.importe_venta ? `$${v.importe_venta}` : '—'}</p>
                  {animal.cliente && (
                    <p><strong>Cabaña:</strong> {animal.cliente.razon_social}</p>
                  )}
                </Card>
              </Col>
            );
          })}
        </Row>
      )}

      {/* Drawer de movimientos */}
      <Drawer
        title={movimientosData ? `Movimientos: ${movimientosData.animal?.nom_animal}` : 'Movimientos'}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        width={640}
      >
        {loadingMov ? (
          <PujaSpinner />
        ) : movimientosData ? (
          <>
            <p>
              <strong>Tu stock hembra:</strong> {movimientosData.stock_usuario?.hembra ?? 0} embriones
              &nbsp;|&nbsp;
              <strong>Tu stock macho:</strong> {movimientosData.stock_usuario?.macho ?? 0} dosis
            </p>
            <Tabs
              items={[
                {
                  key: 'hembra',
                  label: 'Embriones (Hembra)',
                  children: (
                    <Table
                      scroll={{ x: 'max-content' }}
                      rowKey="id_movimiento"
                      dataSource={movimientosData.movimientos_hembra || []}
                      columns={colsHembra}
                      pagination={false}
                      size="small"
                    />
                  ),
                },
                {
                  key: 'macho',
                  label: 'Dosis Semen (Macho)',
                  children: (
                    <Table
                      scroll={{ x: 'max-content' }}
                      rowKey="id_movimiento"
                      dataSource={movimientosData.movimientos_macho || []}
                      columns={colsMacho}
                      pagination={false}
                      size="small"
                    />
                  ),
                },
              ]}
            />
          </>
        ) : null}
      </Drawer>
    </div>
  );
};

export default MisAnimales;
